import { TOKEN, apiUrl } from "../Constants"
import api from "./ApiService"
import { Stack } from "@mui/material"

const BASE_URL = apiUrl + "/api/contract"

interface IEmploymentContract {
  nameFile?: string
  dmsFileId: string
  created_by: string
  modified_by?: string
  is_active?: boolean
  id?: string
}

interface IContract {
  contractId: string
  positionName: string
  data: any
  typeEC: string
  dmsFileId: string
  created_by: string
  nameFile?: string
}

export function addEmploymentContractData(data: IEmploymentContract) {
  const config = {
    headers: { Authorization: `Bearer ${TOKEN}` },
  }
  return api.post(`${BASE_URL}/add-employment-contract`, data, config)
}

export function updateEmploymentContract(data: any) {
  const config = {
    headers: { Authorization: `Bearer ${TOKEN}` },
  }

  return api.put(`${BASE_URL}/update-employment-contract`, data, config)
}

export function getEmploymentContractById(data: any) {
  const config = {
    headers: { Authorization: `Bearer ${TOKEN}` },
  }

  return api.get(`${BASE_URL}/get-employment-contract/${data}`, config)
}

export function getAllEmploymentContract(status: string) {
  const config = {
    headers: { Authorization: `Bearer ${TOKEN}` },
  }

  return api.get(`${BASE_URL}/get-all-employment-contract/${status}`, config)
}

export function addContractData(data: IContract) {
  const config = {
    headers: { Authorization: `Bearer ${TOKEN}` },
  }
  return api.post(`${BASE_URL}/add-contract-employee`, data, config)
}

export function getContractByUserId(data: any) {
  const config = {
    headers: { Authorization: `Bearer ${TOKEN}` },
  }

  return api.get(`${BASE_URL}/get-contract-user/${data}`, config)
}

export function updateContractById(data: any) {
  const config = {
    headers: { Authorization: `Bearer ${TOKEN}` },
  }

  return api.put(`${BASE_URL}/update-contract-id`, data, config)
}

export function updateContractByUserId(data: any) {
  const config = {
    headers: { Authorization: `Bearer ${TOKEN}` },
  }

  return api.put(`${BASE_URL}/update-contract-user`, data, config)
}

